import { ReactNode } from "react";

import DocumentationIconButton from "components/DocumentationIconButton";
import SearchInput from "components/SearchInput";
import { SEARCH_PLACEHOLDERS } from "constants/searchPlaceholders";
import ViewHeader from "components/ViewHeader";
import ViewHeaderTitle from "components/ViewHeader/Title";
import ViewHeaderWrapper from "components/ViewHeader/Wrapper";
import useTitle from "hooks/useTitle";
import useTypedContext from "hooks/useTypedContext";
import { getDocsUrl } from "utils/getDocsUrl";
import { AccountContext } from "views/AccountWrapper";
import LinkButton from "ds/components/Button/LinkButton";
import FiltersMobileTriggerButton from "components/Filters/MobileTriggerButton";
import useCanCreateContext from "shared/Context/access/useCanCreateContext";
import Tooltip from "ds/components/Tooltip";
import DesktopView from "components/Mobile/DesktopView";
import MobileView from "components/Mobile/MobileView";

type ContextsPageLayoutProps = {
  children?: ReactNode;
  hideActions?: boolean;
};

const ContextsPageLayout = ({ children, hideActions }: ContextsPageLayoutProps) => {
  const { accountName } = useTypedContext(AccountContext);

  const canCreateContext = useCanCreateContext();

  useTitle(`Contexts · ${accountName}`);

  return (
    <>
      <ViewHeader firstLevel>
        <ViewHeaderWrapper>
          <ViewHeaderTitle>Contexts</ViewHeaderTitle>
          <MobileView>
            <Tooltip
              active={!!canCreateContext.message}
              on={(props) => (
                <LinkButton
                  {...props}
                  to="/new/context"
                  variant="primary"
                  disabled={!canCreateContext.result}
                >
                  Create context
                </LinkButton>
              )}
            >
              {canCreateContext.message}
            </Tooltip>
          </MobileView>
        </ViewHeaderWrapper>
        {!hideActions && (
          <ViewHeaderWrapper direction="row" align="end" shrink="0">
            <SearchInput placeholder={SEARCH_PLACEHOLDERS.CONTEXTS} filtersOrderSettingsKey="TBA" />
            <FiltersMobileTriggerButton />
            <DesktopView>
              <DocumentationIconButton
                href={getDocsUrl("/concepts/configuration/context")}
                tooltipText="Go to contexts documentation"
              />

              <Tooltip
                active={!!canCreateContext.message}
                on={(props) => (
                  <LinkButton
                    {...props}
                    to="/new/context"
                    variant="primary"
                    disabled={!canCreateContext.result}
                  >
                    Create context
                  </LinkButton>
                )}
              >
                {canCreateContext.message}
              </Tooltip>
            </DesktopView>
          </ViewHeaderWrapper>
        )}
      </ViewHeader>

      {children}
    </>
  );
};

export default ContextsPageLayout;
